import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { Quote } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  return <AnimatedSection className="bg-barber-dark/50 border-y border-white/5" data-id="element-221">
      <div className="text-center mb-16" data-id="element-222">
        <h2 className="text-4xl md:text-5xl font-oswald font-bold mb-4" data-id="element-223">
          {t.testimonials.title}
        </h2>
        <div className="w-20 h-1 bg-barber-gold mx-auto" data-id="element-224"></div>
      </div>

      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-225">
        {t.testimonials.items.map((item, i) => <div key={i} className="bg-barber-black p-8 rounded-lg border border-white/5 relative" data-id="element-226">
            <Quote className="text-barber-gold/20 absolute top-6 right-6" size={60} data-id="element-227" />
            <p className="text-lg text-gray-300 italic mb-8 relative z-10" data-id="element-228">
              "{item.quote}"
            </p>
            <div className="flex flex-col" data-id="element-229">
              <span className="font-oswald font-bold text-xl text-white" data-id="element-230">
                {item.name}
              </span>
              <span className="text-barber-gold text-sm uppercase tracking-wider" data-id="element-231">
                {item.role}, {item.location}
              </span>
            </div>
          </div>)}
      </div>
    </AnimatedSection>;
}